// extracted by mini-css-extract-plugin
module.exports = {"zero":"Slider_zero__pZEnn","last":"Slider_last__ZmrFK","slider":"Slider_slider___7VBv"};